import { Button } from "./button";
import { SelectableRow } from "./SelectableRow";

export interface MultiSelectItem {
  id: string;
  label: string;
}

interface MultiSelectPanelProps {
  items: MultiSelectItem[];
  selectedIds: string[];
  onToggle: (id: string) => void;
  onSelectAll: () => void;
  onSave: () => void;
  onCancel: () => void;
  isAllSelected: boolean;
  isSaveDisabled?: boolean;
  selectAllLabel: string;
  saveLabel: string;
  cancelLabel: string;
}

export function MultiSelectPanel({
  items,
  selectedIds,
  onToggle,
  onSelectAll,
  onSave,
  onCancel,
  isAllSelected,
  isSaveDisabled = false,
  selectAllLabel,
  saveLabel,
  cancelLabel,
}: MultiSelectPanelProps) {
  return (
    <div className="space-y-3 max-h-[300px]">
      <div className="space-y-1 overflow-auto max-h-[250px] scrollbar scrollbar-thumb-gray-400 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-500">
        <SelectableRow
          label={selectAllLabel}
          isSelected={isAllSelected}
          onToggle={onSelectAll}
        />

        {items.map((item) => {
          const isSelected = selectedIds.includes(item.id);

          return (
            <SelectableRow
              key={item.id}
              label={item.label}
              isSelected={isSelected}
              onToggle={() => onToggle(item.id)}
            />
          );
        })}
      </div>

      <div className="flex gap-2 pt-2 border-t">
        <Button
          variant="outline"
          size="sm"
          onClick={onCancel}
          className="flex-1"
          type="button"
        >
          {cancelLabel}
        </Button>
        <Button
          size="sm"
          onClick={onSave}
          disabled={isSaveDisabled}
          className="flex-1"
          type="button"
        >
          {saveLabel}
        </Button>
      </div>
    </div>
  );
}

